import TemplateCreateDocumentPayStubNew from './TemplateCreateDocumentPayStubNew'

export default TemplateCreateDocumentPayStubNew
